import { ArrowNarrowLeft, Block, Button, Cube01, useStyletron, } from "@mezo-org/mezo-clay";
import React, { useCallback } from "react";
import { usePassportContext } from "../../../hooks/usePassportContext";
import { getAddressExplorerUrl } from "../../../utils/address";
import useDropdownStore, { DropdownView } from "../../../stores/dropdownStore";
const buttonStartEnhancerSize = 12;
const commonButtonProps = {
    kind: "secondary",
    size: "xsmall",
    overrides: {
        BaseButton: {
            style: {
                flex: 1,
            },
        },
        StartEnhancer: {
            style: {
                stroke: "currentColor",
            },
        },
    },
};
export default function AccountAddressActions(props) {
    const { address } = props;
    const [, theme] = useStyletron();
    const { environment } = usePassportContext();
    const blockExplorerUrl = getAddressExplorerUrl(address, "mezo", environment === "testnet");
    const setDropdownView = useDropdownStore((state) => state.setView);
    const handleReceiveClick = useCallback(() => {
        setDropdownView(DropdownView.RECEIVE);
    }, [setDropdownView]);
    return (React.createElement(Block, { display: "flex", alignItems: "center", backgroundColor: "transparent", marginBottom: theme.sizing.scale600, overrides: {
            Block: {
                style: {
                    gap: theme.sizing.scale600,
                },
            },
        } },
        React.createElement(Button, { startEnhancer: React.createElement(Cube01, { size: buttonStartEnhancerSize }), "$as": "a", href: blockExplorerUrl, target: "_blank", ...commonButtonProps }, "View Mezo Explorer"),
        React.createElement(Button, { onClick: handleReceiveClick, startEnhancer: React.createElement(ArrowNarrowLeft, { size: buttonStartEnhancerSize, overrides: {
                    Svg: {
                        style: {
                            transform: "rotate(-45deg)",
                        },
                    },
                } }), ...commonButtonProps }, "Receive")));
}
//# sourceMappingURL=AccountAddressActions.js.map